import playersApi from "../api/players";
import ReduxTypes from "../consts/ReduxTypes";
import { sessionExpired } from "../api/helper";

export const searchPlayers = (text: string, callback: any) => {
  return (dispatch: any) => {
    playersApi
      .searchByUsername(text)
      .then((res: any) => {
        callback(res, null);
      })
      .catch((err: any) => {
        if (err?.response?.status === 404) {
          callback([], null);
        } else {
          callback([], err);
        }
      });
  };
};

export const addPlayerToFav = (id: string, callback?: (err: any) => void) => {
  return (dispatch: any) => {
    playersApi
      .addToFav(id)
      .then(() => {
        dispatch({ type: ReduxTypes.ADD_PLAYER_FAV, id });
        if (callback) callback(null);
      })
      .catch((err: any) => {
        sessionExpired();
        if (callback) callback(err);
      });
  };
};

export const removePlayerFromFav = (id: string, callback?: (err: any) => void) => {
  return (dispatch: any) => {
    playersApi
      .removeFromFav(id)
      .then(() => {
        dispatch({ type: ReduxTypes.REMOVE_PLAYER_FAV, id });
        if (callback) callback(null);
      })
      .catch((err: any) => {
        sessionExpired();
        if (callback) callback(err);
      });
  };
};
